import React, { useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';
// components
import ToggleButton from './ToggleButton';
import SearchBox from './SearchBox';
// Hooks
import { useOnClickOutside } from 'shared/../hooks';
// Consts
import { VIEW_ORDERS, VIEW_SAFETY, VIEW_PRICING_QUOTES } from 'shared/../constants/UserAccess';

const SearchBoxToggle = ({ history }) => {
  const [show, setShow] = useState(false);

  const onClick = () => setShow(!show);

  const searchBoxRef = useRef(null);

  const handleClose = () => {
    if (!show) {
      return;
    }
    setShow(false);
  };

  useOnClickOutside(searchBoxRef, handleClose);

  const searchHandler = (path, searchTerm) => {
    const searchString = searchTerm.join(',');
    history.push(`${path}?search=${searchString}`);
    handleClose();
  };

  const searchButtons = history.location.pathname.indexOf('/safety') === 0
    ? [
      {
        id: 'safety-search-orders-button',
        title: 'Orders',
        tooltip: 'Search by Pro Number, Equipment Number, PO Number, Invoice Number, Invoice Ref # or BOL/Bkg',
        search: (searchTerm) => searchHandler('/orders/orders', searchTerm),
        role: VIEW_ORDERS,
      },
      {
        id: 'safety-search-drivers-button',
        title: 'Drivers',
        tooltip: 'Search by Name, Number, Cell Phone or Email',
        search: (searchTerm) => searchHandler('/safety/drivers', searchTerm),
        role: VIEW_SAFETY,
      },
      {
        id: 'safety-search-trucks-button',
        title: 'Trucks',
        tooltip: 'Search by VIN or License Plate',
        search: (searchTerm) => searchHandler('/safety/trucks', searchTerm),
        role: VIEW_SAFETY,
      },
      {
        id: 'safety-search-owners-button',
        title: 'Owners',
        tooltip: 'Search by Name, DBA, Email, Phone or Tax ID',
        search: (searchTerm) => searchHandler('/safety/owners', searchTerm),
        role: VIEW_SAFETY,
      },
    ] : [
      {
        id: 'safety-search-orders-button',
        title: 'Orders',
        tooltip: 'Search by Pro Number, Equipment Number, PO Number, Invoice Number, Invoice Ref # or BOL/Bkg',
        search: (searchTerm) => searchHandler('/orders/orders', searchTerm),
        role: VIEW_ORDERS,
      },
      {
        id: 'safety-search-quotes-button',
        title: 'Quotes',
        tooltip: 'Search by Number, Description',
        search: (searchTerm) => searchHandler('/pricing/quotes', searchTerm),
        role: VIEW_PRICING_QUOTES,
      },
    ];

  return (
    <>
      {show && <div className="search-box-background" />}
      <div ref={searchBoxRef} className="search-box">
        <ToggleButton id="safety-search-button" active={show} onClick={onClick} />
        <SearchBox
          visible={show}
          handleClose={handleClose}
          searchEntities={searchButtons}
        />
      </div>
    </>
  );
};

export default withRouter(SearchBoxToggle);
